import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { parseNextWorkspaceFreeQuota, type NextWorkspaceFreeQuota } from "@/lib/free-quota";

export function useNextWorkspaceFreeQuota(enabled: boolean): NextWorkspaceFreeQuota | null {
  const [state, setState] = useState<NextWorkspaceFreeQuota | null>(null);

  useEffect(() => {
    if (!enabled) {
      setState(null);
      return;
    }
    let mounted = true;
    void (async () => {
      const { data, error } = await supabase.rpc("next_workspace_free_quota" as never);
      if (!mounted) return;
      setState(error ? null : parseNextWorkspaceFreeQuota(data));
    })();
    return () => { mounted = false; };
  }, [enabled]);

  return state;
}
